/** A bucket bound: a number, null for "no bound", or a nested `[from, to]` pair. */
type BucketBound = number | null | undefined;
type BucketInput = BucketBound | string | [BucketBound, BucketBound];

function formatBucketValue(from: BucketBound | string, to: BucketBound | string): string | null {
    if (from === undefined && to === undefined) {
        return null;
    }

    if (from === undefined) {
        if (to === null) return '∞';
        return `${to}`;
    }

    if (to === undefined) {
        if (from === null) return '∞';
        return `${from}`;
    }

    if (from === null && to === null) return '∞';
    if (from === null) return `<${to}`;
    if (to === null) return `${from}+`;

    return `${from} - ${to}`;
}

function toBound(value: BucketInput): BucketBound | string {
    if (value === null) return null;
    return Array.isArray(value) ? formatBucketValue(value[0], value[1]) : value;
}

interface FormattedBucketInput {
    from: BucketInput;
    to: BucketInput;
    metric?: string;
}

/** `120 - 140 g`, `<120 g`, `140+ g` or `∞`, wrapped in a one-element array. */
function formattedBucket({ from, to, metric = '' }: FormattedBucketInput): [string | null] {
    const formatted = formatBucketValue(toBound(from), toBound(to));

    return [metric ? `${formatted} ${metric}` : formatted];
}

export default formattedBucket;
